import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {AppContainerModule, AppContainerOptions, APP_CONTAINER_SETTINGS} from '@mydocma/app-container';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MainComponent } from './main/main.component';
import {HttpClient, HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import {AuthModule, AUTHSETTINGS, AUTHSTORAGE} from '@mydocma/auth';
import {ProjectModule} from '@mydocma/project';
import {CustomerModule} from '@mydocma/customer';
import {MediaQueryService, MediatorService, MYDOCMASETTINGS} from '@mydocma/core';
import { ModuleTranslateLoader } from '@larscom/ngx-translate-module-loader';
import {TranslateLoader, TranslateModule, TranslateService} from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { ResizeModule } from '@mydocma/component-library';
import { RedirectPageComponent } from './redirect-page/redirect-page.component';
import { CustomerInterceptor } from './interceptors/customer.interceptor';


export function createTranslateLoader(http: HttpClient) {
  const baseTranslateUrl = './assets/i18n';

  return new ModuleTranslateLoader(http, {
    modules: [
      { baseTranslateUrl  },
      { moduleName: 'bp', baseTranslateUrl },
      { moduleName: 'app-container', baseTranslateUrl },
      { moduleName: 'project', baseTranslateUrl },
      {moduleName: 'comp-lib', baseTranslateUrl},
      { moduleName: 'customer', baseTranslateUrl },
    ],
  });
}
@NgModule({
  declarations: [
    AppComponent,
    MainComponent,
    RedirectPageComponent
   ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    AppContainerModule,
    ResizeModule,
    AuthModule.forRoot(),
    CustomerModule.forRoot(),
    ProjectModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    AppContainerOptions,
    {provide: AUTHSETTINGS, useValue: environment.authConfig},
    {provide: AUTHSTORAGE, useValue: sessionStorage},
    {provide: MYDOCMASETTINGS, useValue: environment.mydocmaConfig},
    {provide: APP_CONTAINER_SETTINGS, useValue: {}},
    { provide: HTTP_INTERCEPTORS, useClass: CustomerInterceptor, multi: true },
    // {provide: US_CONFIG, useValue: environment.usConfig },
    MediatorService,
    MediaQueryService,
  ],
  bootstrap: [AppComponent]
})

export class AppModule {
  constructor(
    private translate: TranslateService,
  ) {
    this.translate.addLangs(['en', 'de']);
    this.translate.setDefaultLang('de');
    this.translate.use('de');
  }
 }
